define('models/NewsFlagModel',['underscore', 'app', 'ObjectModel', 'LocalStorage', 'UrlFactory'], function (_, app, ObjectModel, LocalStorage, UrlFactory) {
    //
    // Model News
    //
    var NewsFlagModelPrototype = {

        name: 'NewsFlagModel',
        idAttribute: 'id_news_flag',
        route: 'apiNewsFlagModel',
        defaults:{
            news:[]
        },

        initialize: function () {
            // ObjectModel constructor heritage
            ObjectModel.prototype.initialize.apply(this, arguments);
            //
            if (!this.get(this.idAttribute)) {
                this.attributes[this.idAttribute] = this.get('id');
            }
        },
        contains:function(id_news){
            return _.contains(this.get('news') ,id_news);
        },
        getName: function () {
            return this.get('name')
        },
        getDescription: function () {
            return this.get('description')
        },
        isVisible: function () {
            return this.get('visible');
        },
        isAllNews: function(){
            return this.get('is_all_news')
        },
        isTitleVisible: function(){
            return this.get('is_title_visible')
        },
        getPictureUrl:function(){
            var url = app.getPictureUrl(this.get('image'),'NewsFlag','1920x540','JPG',this.getName());
            return url;
        },
        getUrl:function(){
            var model = this, url;
            if(model.isAllNews()){
                url = UrlFactory.getUrl('newsHome');
            } else{
                url = UrlFactory.getUrl('newsFlag',{url_rewrite:model.get('url_rewrite')});
            }
           return url;
        }
    };

    var NewsFlagModel = ObjectModel.extend(LocalStorage).extend(NewsFlagModelPrototype);

    return NewsFlagModel;
});
